import React, { useEffect } from 'react'
import { LoadingOutlined } from '@ant-design/icons'

import css from './index.module.scss'
import { LoaderType } from './types'


/** Компонент Loader */
export const Loader = ({ 
    isOpen, title, backdrop = false, 
    color = 'var(--color_txt_accent)', 
    borderRadius
}: LoaderType) => {
    useEffect(() => {
        switch (isOpen) {
            case true: document.body.style.overflow = 'hidden'; break
            case false: document.body.style.overflow = 'unset'; break
        }
    }, [isOpen])

    /** Стили компоненты */
    const componentStyle: React.CSSProperties & { '--loader-border-radius'?: string } = {
        position: `${backdrop ? 'absolute' : 'fixed'}`, 
        borderRadius: borderRadius || (backdrop ? 'inherit' : 'var(--border_radius_default)'),
        '--loader-border-radius': borderRadius,
        color
    }


    return (
        <div className={`${css.wrapper} ${!backdrop ? css.fullscreen : ''} ${isOpen ? css.open : css.close}`} style={componentStyle} aria-hidden={!isOpen}>
            <svg className={css.track} width='100%' height='100%' aria-hidden='true' focusable='false'>
                <rect className={css.outline} x='1.5' y='1.5' />
                <rect className={`${css.progressLayer} ${css.progressFadeOuter}`} x='1.5' y='1.5' pathLength='100' />
                <rect className={`${css.progressLayer} ${css.progressFadeFar}`} x='1.5' y='1.5' pathLength='100' />
                <rect className={`${css.progressLayer} ${css.progressFadeSoft}`} x='1.5' y='1.5' pathLength='100' />
                <rect className={`${css.progressLayer} ${css.progressFadeInner}`} x='1.5' y='1.5' pathLength='100' />
                <rect className={`${css.progressLayer} ${css.progressFadeNear}`} x='1.5' y='1.5' pathLength='100' />
                <rect className={`${css.progressLayer} ${css.progress}`} x='1.5' y='1.5' pathLength='100' />
            </svg>
            <div className={`${css.content} ${!title ? css.compact : ''}`} role='status' aria-live='polite' aria-atomic='true' aria-label={title || 'Загрузка'}>
                <LoadingOutlined className={css.indicator} aria-hidden='true' />
                {title && <span className={css.title}>{title}</span>}
            </div>
        </div>
    )
}